var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#d3d5d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.66675 13.333s.44444.6667 1.33333.6667 1.33333-.6667 1.33333-.6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.0001 6c0 1.33333 1.3333 2 1.3333 3.33333 0 1.99997-2.9629 2.66667-5.33332 2.66667-2.37036 0-5.33333-.6667-5.33333-2.66667 0-1.33333 1.33333-1.83908 1.33333-3.33333 0-2 1.33334-4 4-4 2.66662 0 4.00002 2 4.00002 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.09712d8be40350bf361d5f93338a5122.svg";
export { ForwardRef as ReactComponent };